import { Controller } from 'stimulus';

const HIDDEN_CLASS = 'hidden';

export default class extends Controller {
  static targets = ['cvcPageFields'];

  connect() {
    this.#requireCvcRecollectionCheckbox?.addEventListener('change', this.toggleCvcPageFields);
    this.toggleCvcPageFields();
  }

  disconnect() {
    this.#requireCvcRecollectionCheckbox?.removeEventListener('change', this.toggleCvcPageFields);
  }

  toggleCvcPageFields = () => {
    if (!this.hasCvcPageFieldsTarget) {
      return;
    }

    this.cvcPageFieldsTarget.classList.toggle(HIDDEN_CLASS, !this.#requireCvcRecollectionChecked);
  };

  get #requireCvcRecollectionCheckbox() {
    return this.element.querySelector('input[type="checkbox"][name*="[require_cvc_recollection]"]');
  }

  get #requireCvcRecollectionChecked() {
    return this.#requireCvcRecollectionCheckbox?.checked === true;
  }
}
